import { ObservableFromFetch } from "../ObservableFromFetch"

export default function RoleOrderSecurityCheckObservable(roleID: number) {
  return ObservableFromFetch<boolean>(`FFOrderRoleOrderSecurity/CheckRoleOrderSecurity?roleID=${roleID}`)
}
